.load { display: inline-flex; align-items: center; gap: 8px; font-family: var(--font-mono); font-size: 12px; }
.bar { display: inline-block; height: 8px; background: var(--pink); }
.bar[data-high='true'] { background: var(--hot); }
.reason, .pending, .failed { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.8px; }
.reason { color: var(--text-secondary); }
.pending { color: var(--ink); background: var(--amber); padding: 2px 6px; }
.failed { color: var(--hot); }
.dash { display: none; }
.none { font-family: var(--font-mono); font-size: 12px; color: var(--text-secondary); }

@media (max-width: 639px) {
  .load { font-size: 13px; }
  .none { font-size: 13px; }
  .pending { font-size: 9px; }
  .dash { display: inline; font-family: var(--font-mono); font-size: 13px; color: var(--text-secondary); }
  .reason { display: none; }
  button.failed { min-width: 64px; min-height: 44px; border: 1.5px solid var(--hot); font-size: 10px; letter-spacing: 0.6px; }
}
